import { VueRegistration } from '@abaco/web-common/src/app';
const CONTEXT = "EARTHWORM";

const globals: VueRegistration = {
    "EarthWormPieChartTile": {
        meta: {
            i18nDescrKey: "earthworm-edu-pie-chart-tile",
            filters: [],
            pinnable: true,
            tag: CONTEXT
        },
        component: () => import("./components/tiles/EarthWormPieChartTile.vue")
    },
    "EarthWormTableForChartsTile": {
        meta: {
            i18nDescrKey: "earthworm-table-for-charts-tile",
            filters: [],
            pinnable: true,
            tag: CONTEXT
        },
        component: () => import("./components/tiles/EarthWormTableForChartsTile.vue")
    },
    "EarthWormBarChartTile": {
        meta: {
            i18nDescrKey: "earthworm-edu-bar-chart-tile",
            filters: [],
            pinnable: true,
            tag: CONTEXT
        },
        component: () => import("./components/tiles/EarthWormBarChartTile.vue")
    },
    "EarthWormMapTile": {
        meta: {
            i18nDescrKey: "earthworm-edu-map-chart-tile",
            filters: [],
            pinnable: true,
            tag: CONTEXT
        },
        component: () => import("./components/tiles/EarthWormMapTile.vue")
    },
    "EarthWormIncomePieChart": {
        meta: {
            i18nDescrKey: "income-pie-chart-tile",
            filters: [],
            pinnable: true,
            tag: CONTEXT
        },
        component: () => import("./components/tiles/EarthWormIncomePieChartTile.vue")
    },
    "EarthWormIncomeBarChart": {
        meta: {
            i18nDescrKey: "income-bar-chart-tile",
            filters: [],
            pinnable: true,
            tag: CONTEXT
        },
        component: () => import("./components/tiles/EarthWormIncomeBarChartTile.vue")
    },
    "EarthWormIncomeMixedChartTile": {
        meta: {
            i18nDescrKey: "income-mixed-chart-tile",
            filters: [],
            pinnable: true,
            tag: CONTEXT
        },
        component: () => import("./components/tiles/EarthWormIncomeMixedChartTile.vue")
    },
    "EarthWormRadarValuesChartTile": {
        meta: {
            i18nDescrKey: "radar-values-chart-tile",
            filters: [],
            pinnable: true,
            tag: CONTEXT
        },
        component: () => import("./components/tiles/EarthWormRadarValuesChartTile.vue")
    },
    "EarthWormRadarScoreChartTile": {
        meta: {
            i18nDescrKey: "radar-score-chart-tile",
            filters: [],
            pinnable: true,
            tag: CONTEXT
        },
        component: () => import("./components/tiles/EarthWormRadarScoreChartTile.vue")
    },
    "EarthWormRadarMap": {
        meta: {
            i18nDescrKey: "radar-map",
            filters: [],
            pinnable: true,
            tag: CONTEXT
        },
        component: () => import("./components/tiles/EarthWormRadarMap.vue")
    },
};

export default globals;
